import React, { useEffect, useState } from "react";
import rightArrow from "../images/right-arrow.png";
import Vector from "../images/Vector.png";

function HeroHome() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    function handleResize() {
      setIsSmallScreen(window.innerWidth < 768);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="relative mx-6">
      <div className="max-w-6xl mx-auto">
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">
          <div className="text-center pb-12 md:pb-16">
            <div className="grid gap-4 md:grid-cols-2">
              <div>
                <div className="text-4xl md:text-5xl font-extrabold leading-tighter tracking-tighter mb-4 text-left">
                  <span className="text-white font-medium">
                    <u className="text-blue-500">
                      <i>LISTUS</i>
                    </u>
                    <img
                      src={rightArrow}
                      alt="rightArrow"
                      className="inline align-middle mx-2"
                    />
                    Super Apps as a service.
                  </span>
                </div>
                <div className="text-xl text-justify">
                  <span style={{ color: "#9FB6D0" }}>
                    Embed, Customize & Streamline. All in One.
                  </span>
                </div>
                <div className="text-xl text-justify">
                  <button
                    className="try-now-button"
                    style={{ color: "#FFF" }}
                    onClick={() =>
                      window.open("https://app.listus.xyz/landing-page")
                    }
                  >
                    Try Now
                  </button>
                  <img
                    src={Vector}
                    alt="Vector"
                    className={`inline align-middle mx-4 mt-10 ${
                      isSmallScreen ? "rotate-45-responsive" : ""
                    }`}
                  />
                </div>
              </div>

              <div className="flex justify-center mt-10">
                <iframe
                  src="https://app.listus.xyz/landing-page"
                  style={{ borderRadius: "10px" }}
                  width="462px"
                  height="717px"
                  title="Listus"
                  frameBorder="1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroHome;
